import { omit, pulseMerge } from '@spt-tracking/utils';
import actorBuilder, { defaultValue as actorDefaultValue } from './actor';
import consentsBuilder from './consents';
import deviceBuilder, { defaultValue as deviceDefaultValue } from './device';
import experimentMetadataBuilder, { defaultValue as experimentMetadataDefaultValue } from './experimentMetadata';
import experimentsBuilder, { defaultValue as experimentsDefaultValue } from './experiments';
import locationBuilder, { defaultValue as locationDefaultValue } from './location';
import objectBuilder, { defaultValue as objectDefaultValue } from './objects/objects';
import originBuilder, { defaultValue as originDefaultValue } from './origin';
import providerBuilder, { defaultValue as providerDefaultValue } from './provider';
import trackerBuilder, { defaultValue as trackerDefaultValue } from './tracker';
export const DEFAULT_SCHEMA_LOCATION = 'schema.schibsted.com';
function routableEventDefaults(eventInput) {
    return pulseMerge({
        actor: actorDefaultValue(),
        provider: providerDefaultValue(),
    }, eventInput);
}
/**
 * Implements https://schibsted.ghe.com/data-platform/event-formats/blob/master/schema/master/events/base-routable-event.json
 */
export function routableEvent({ eventInput, sdkConfig } = {}) {
    return Object.assign({}, eventInput, {
        schema: eventInput?.schema ||
            `http://${sdkConfig?.schemaLocation || DEFAULT_SCHEMA_LOCATION}/events/base-routable-event.json/238.json#`,
        provider: providerBuilder(eventInput),
        actor: actorBuilder(eventInput),
    });
}
routableEvent.defaults = routableEventDefaults;
/**
 * Add default value to TrackerEventInput.
 * @todo type-bug
 */
function trackerEventInput(eventInput) {
    return pulseMerge({
        actor: actorDefaultValue(),
        experiments: experimentsDefaultValue(),
        experimentMetadata: experimentMetadataDefaultValue(),
        device: deviceDefaultValue(),
        location: locationDefaultValue(),
        object: objectDefaultValue(),
        origin: originDefaultValue(),
        provider: providerDefaultValue(),
        tracker: trackerDefaultValue(),
    }, eventInput);
}
/**
 * Implements https://schibsted.ghe.com/data-platform/event-formats/blob/master/schema/master/events/tracker-event.json
 */
export function trackerEvent({ eventInput, sdkConfig } = {}) {
    const parentInput = trackerEventInput(eventInput);
    const pageViewIdInput = eventInput?.pageViewId;
    const pageViewIdSdk = sdkConfig?.pageViewId;
    return Object.assign({}, omit(eventInput, ['type']), {
        '@type': eventInput?.type || 'View',
        pageViewId: pageViewIdInput || pageViewIdSdk,
        schema: eventInput?.schema ||
            `http://${sdkConfig?.schemaLocation || DEFAULT_SCHEMA_LOCATION}/events/tracker-event.json/351.json`,
        actor: actorBuilder(parentInput),
        consents: consentsBuilder(parentInput),
        experiments: experimentsBuilder(parentInput),
        experimentMetadata: experimentMetadataBuilder(parentInput),
        device: deviceBuilder(parentInput),
        location: locationBuilder(parentInput),
        object: objectBuilder(parentInput),
        origin: originBuilder(parentInput),
        provider: providerBuilder(parentInput),
        target: parentInput.target && objectBuilder(Object.assign({}, parentInput, { object: parentInput.target })),
        tracker: trackerBuilder(parentInput),
    });
}
trackerEvent.defaults = trackerEventInput;
export function engagementEvent({ eventInput, sdkConfig } = {}) {
    return Object.assign(trackerEvent({ eventInput, sdkConfig }), {
        schema: eventInput?.schema ||
            `http://${sdkConfig?.schemaLocation || DEFAULT_SCHEMA_LOCATION}/events/engagement-event.json/378.json`,
        '@type': 'Engagement',
    });
}
engagementEvent.defaults = trackerEventInput;
export function identityEvent({ eventInput = {} } = {}) {
    return eventInput;
}
identityEvent.defaults = () => ({});
